/*
 * File: InsuranceHeader.js
 * Project: mp-mobile-app
 *
 * Copyright (c) 2019 MacPractice, Inc. All rights reserved.
 *
 * Description: Creates and styles the Insurance Company and Plan section headers
 */
import React from "react";
import { Typography } from "@material-ui/core";
import { withStyles } from "@material-ui/core/styles";
import PropTypes from "prop-types";

const styles = theme => ({
  insuranceHeader: {
    width: "100%",
    paddingLeft: theme.spacing(2.5),
    marginTop: theme.spacing(2.5),
    color: theme.palette.common.title,
    fontWeight: 400
  },
  planHeader: {
    width: "100%",
    paddingLeft: theme.spacing(2.5),
    color: theme.palette.common.title
  }
});

const InsuranceHeader = ({ classes, insurance }) => (
  <React.Fragment>
    <Typography className={classes.insuranceHeader} variant="h5">
      {insurance.carrier}
    </Typography>
    <Typography className={classes.planHeader} variant="body1">
      {insurance.plan}
    </Typography>
  </React.Fragment>
);

InsuranceHeader.propTypes = {
  classes: PropTypes.object.isRequired,
  insurance: PropTypes.object.isRequired
};

export default withStyles(styles)(InsuranceHeader);
